import { render, staticRenderFns } from "./AddBonusModal.vue?vue&type=template&id=19e5f4dc"
import script from "./AddBonusModal.vue?vue&type=script&lang=js"
export * from "./AddBonusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports